<template>
    <app-modal modal-id="details-view-modal" modal-size="full-width" modal-alignment="top" @close-modal="closeModal">
        <template slot="header">
            <h4>{{ $t('all_deals') }}</h4>
            <button type="button" class="close outline-none" data-dismiss="modal" aria-label="Close">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <app-table :id="tableId" :options="options"/>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click.prevent="closeModal">
                {{ $t('close') }}
            </button>
        </template>
    </app-modal>
</template>

<script>
    import {numberWithCurrencySymbol} from "@app/Helpers/helpers";
    import {getCustomFileds} from "@app/Mixins/Global/CustomFieldMixin";

    export default {
        name: "ViewAllOrgDealModal",
        props:['id', 'groupBy'],
        data() {
            return {
                numberWithCurrencySymbol,
                tableId: "deal-modal",
                options: {
                    tablePaddingClass: "px-0",
                    tableShadow: false,
                    name: this.$t('deal_table'),
                    url: 'crm/deal-by-person-org?' + 'id=' + this.id + '&condition='+ this.groupBy +'',
                    showHeader: true,
                    columns: [
                        {
                            title: this.$t('title'),
                            type: 'link',
                            key: 'title',
                            sortAble: true,
                            isVisible: true,
                            modifier: (value, row) => {
                                return `crm/deal/${row.id}/details`;
                            }
                        },
                        {
                            title: this.$t('status'),
                            type: 'custom-html',
                            key: 'status',
                            modifier: (value) => {
                                return `<span class="badge badge-pill badge-${value.class ?? 'secondary'}">${value.translated_name}</span>`;

                            }
                        },
                        {
                            title: this.$t('deal_value'),
                            type: 'custom-html',
                            key: 'value',
                            modifier: (value) => {
                                return `<p class="mb-0 d-flex align-items-center text-nowrap">${numberWithCurrencySymbol(value)}</p>`;
                            },
                        },
                        {
                            title: this.$t('organization'),
                            type: 'custom-html',
                            key: 'organization',
                            modifier: (value, row) => {
                                return value
                                    ? value.name
                                    : `<p class="font-size-80 text-secondary">` + this.$t('deal_has_no_organization') + `</p>`;
                            }
                        },
                        {
                            title: this.$t('person'),
                            type: 'custom-html',
                            key: 'person',
                            modifier: (value, row) => {
                                return value
                                    ? value.name
                                    : `<p class="font-size-80 text-secondary">` + this.$t('deal_has_no_person') + `</p>`;
                            }
                        },
                        {
                            title: this.$t('next_activity'),
                            type: 'text',
                            key: 'next_activity',
                        },
                        {
                            title: this.$t('owner'),
                            type: 'custom-html',
                            key: 'owner',
                            modifier: (value, row) => {
                                return value
                                    ? value.full_name
                                    : `<p class="font-size-80 text-secondary">` + this.$t('deal_has_no_owner') + `</p>`
                            }
                        },
                        {
                            title: this.$t("tags"),
                            type: "component",
                            key: "tags",
                            isVisible: true,
                            componentName: "tags-type-column"
                        },
                    ],
                    showAction: false,
                    showSearch: false,
                    showFilter: false,
                    responsive: true,
                    orderBy: 'desc',
                }
            }
        },
        methods: {
            closeModal(value){
                this.$emit('close-modal', value);
            },
        }
    }
</script>